export const DRIVER_STATUS = {
  PROCURED: "procured",
  RTD: "rtd",
  ASSIGNED: "assigned",
  ASSIGNED_REQUESTED: "assigned_requested",
  REJECTED: "rejected",
  MAINTENANCE: "maintenance",
  TENURE_EXPIRED: "tenure-expired",
  PENDING: "pending",
  PENDING_PROCUREMENT: "pendingprocurement",
  UNDER_RECOVERY: "under-recovery",
  RTA: "rta",
  MAINTENANCE_MINOR_REPAIR: "maintainance minor-repair",
  MAINTENANCE_MAJOR_REPAIR: "maintainance major-repair",
  TOTAL_LOSS: "total-loss",
  POLICE_STATION: "police_station",
  READY_IN_WORKSHOP: "ready_in_workshop",
  PERMANENT_DROP: "permanent_drop",
  RECOVERED: "recovered",
  RECOVERY_INITIATED: "recovery_initiated",
  INACTIVE: "inactive",
  DRIVER_RETURNED: "driver_returned",
  TO_ONBOARD: "to_onboard",
  CREATED: "created",
  ONBOARDED: "onboarded",
  ONBOARDING_DROP: "onboarding_drop",
  VA_TO_BE_ASSIGNED: "va to be assigned",
  TEMP_DROP: "temp_drop",
  MAINTENANCE_DROP: "maintenance_drop",
};
export const HUBS = {
  BENGALURU: "bengaluru",
  BENGALURU_CHILD_TESTING: "BengaluruChildTesting",
  DELHI: "delhi",
  HYDERABAD: "hyderabad",
  INDIA: "india",
  MUMBAI: "mumbai",
  PUNE: "pune",
  TEST_HUB: "test hub",
  UBER_BLACK_DELHI_ESCROW: "Uber Black Delhi Escrow",
  UBER_BLACK_MUMBAI: "Uber Black Mumbai",
  HO: "HO",
  UBER_BLACK_DELHI: "Uber Black Delhi",
  UBER_BLACK_BENGALURU: "Uber Black Bengaluru",
  KOLKATA: "kolkata",
  HYDERABAD_AIRPORT_TAXI: "hyderabad airport taxi",
  DELHI_AIRPORT_TAXI: "delhi airport taxi",
};
export const roles = {
  ADMIN: "admin",
  VENDOR: "vendor",
  VERIFICATION: "verification",
  HUB_MANAGER: "hub_manager",
  ONBOARDING: "onboarding",
  DRIVER_MANAGER: "driver_manager",
  FINANCE: "finance",
  PROCUREMENT: "procurement",
  PARKING: "parking",
  RECOVER_AGENT: "recovery_agent",
  SENIOR_DRIVER_MANAGER: "senior_driver_manager",
  TELECALLING: "telecaller",
  FLEET_MANAGER: "fleet_manager",
  FLEET_GENERAL_MANAGER: "fleet_general_manager",
  PROCUREMENT_ADMIN: "procurement_admin",
  COMMERCIAL: "commercial",
  HUB_PROCUREMENT: "hub_procurement",
  FLEET_EXECUTIVE: "fleet_executive",
  WORKSHOP_PARTNER: "workshop_partner",
  TELECALLER_LEAD: "telecaller_lead",
  SUPER_ADMIN: "super_admin",
};

/**
 * Fallback dashboard path when role is missing or not in DEFAULT_LANDING_PAGES.
 * Use this constant everywhere a default segment is needed (e.g. DefaultRoute, DashboardIndexRoute).
 */
export const DEFAULT_DASHBOARD_FALLBACK = "driver_list";

/**
 * Default dashboard page path per role when user lands on "/".
 * Ensure every role that can access the app has an entry here.
 */
export const DEFAULT_LANDING_PAGES = {
  [roles.FLEET_MANAGER]: "maintenance_review_list",
  [roles.FLEET_GENERAL_MANAGER]: "maintenance_review_list",
  [roles.HUB_MANAGER]: "driver_list",
  [roles.ADMIN]: "dashboard",
  [roles.VENDOR]: "fleetPerformance",
  [roles.VERIFICATION]: "driver_list",
  [roles.ONBOARDING]: "driver_list",
  [roles.DRIVER_MANAGER]: "dm_driver_list",
  [roles.SENIOR_DRIVER_MANAGER]: "driver_list",
  [roles.FINANCE]: "driver_list",
  [roles.PROCUREMENT]: "procurement_request",
  [roles.PROCUREMENT_ADMIN]: "approved_cars",
  [roles.PARKING]: "approved_cars",
  [roles.RECOVER_AGENT]: "recovery_dashboard",
  [roles.TELECALLING]: "driver_list",
  [roles.HUB_PROCUREMENT]: "approved_cars",
  [roles.COMMERCIAL]: "driver_list",
  [roles.FLEET_EXECUTIVE]: "bill_upload_list",
  [roles.WORKSHOP_PARTNER]: "maintenance_workshop_bill",
};

export const FLEET_STATUS = {
  PROCURED: "procured",
  RTA: "rta",
  RTD: "rtd",
  REJECTED: "rejected",
  ASSIGNED: "assigned",
  ASSIGNED_REQUESTED: "assigned_requested",
  MAINTENANCE: "maintenance",
  TENURE_EXPIRED: "tenure-expired",
  UNDER_RECOVERY: "under-recovery",
  PENDING_PROCUREMENT: "pendingprocurement",
};
/** GPS vendor options for primary/secondary GPS dropdowns (fleet, recovery). */
export const GPS_VENDOR_OPTIONS = [
  { label: "E Trans", value: "etrans" },
  { label: "Fleetogenic", value: "fleetogenic" },
  { label: "Vt4india", value: "vt4india" },
  { label: "Intellicar", value: "intellicar" },
  { label: "TVS", value: "tvs" },
];

export const CRM_LEAD_SOURCE = [
  { label: "Car Sticker", value: "car sticker" },
  { label: "Facebook", value: "facebook" },
  { label: "Instagram", value: "instagram" },
  { label: "Referral", value: "referral" },
  { label: "Leaflet/Poster", value: "leaflet poster" },
  { label: "Walkin", value: "walkin" },
  { label: "Website", value: "website" },
  { label: "WhatsApp", value: "whatsapp" },
  { label: "Job Portal", value: "job portal" },
  { label: "YouTube", value: "youtube" },
];

export const HUB_PROCESSING_FEES = {
  [HUBS.BENGALURU]: [2360],
  [HUBS.HYDERABAD]: [2360],
  [HUBS.DELHI]: [2360],
  [HUBS.UBER_BLACK_DELHI]: [2360],
  [HUBS.UBER_BLACK_DELHI_ESCROW]: [2360],
  [HUBS.UBER_BLACK_MUMBAI]: [2360],
  default: [2360],
  [HUBS.KOLKATA]: [2360],
  [HUBS.HYDERABAD_AIRPORT_TAXI]: [2360],
  [HUBS.UBER_BLACK_BENGALURU]: [2360],
  // Default for all other hubs
};

// Helper function to get processing fees for a hub
export const getHubProcessingFees = (hubName) => {
  if (!hubName) return HUB_PROCESSING_FEES.default;
  // const normalizedHubName = hubName.toLowerCase();
  return HUB_PROCESSING_FEES[hubName] || HUB_PROCESSING_FEES.default;
};
